var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import i18n from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { Button } from 'syf-component-library/ui/atoms';
import OnlineChatLink from '../../../ui/atoms/OnlineChatLink';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
import { TransactionStatus } from '../../../const/transactionStatus';
var UploadButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", "px;\n"], ["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", "px;\n"])), fontWeights.bold, theme.colors.cyanBlue, fontSizes.root);
var EligibleAdditionalInfo = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: ", "px;\n  max-width: 616px;\n  button {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n  }\n  @media ", " {\n    max-width: 350px;\n  }\n"], ["\n  padding-top: ", "px;\n  max-width: 616px;\n  button {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n  }\n  @media ", " {\n    max-width: 350px;\n  }\n"])), spacing.small, query.lessThanMedium);
var EligibleUploadText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  button {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n  }\n"], ["\n  button {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n  }\n"])));
var showAdditionalMessagingStatus = [
    TransactionStatus.SET_1,
    TransactionStatus.SET_2,
    TransactionStatus.SET_3,
    TransactionStatus.SET_4,
    TransactionStatus.SET_22,
    TransactionStatus.SET_23
];
var DisputeInfoModalHeaderText = function (_a) {
    var additionalInfoEnabled = _a.additionalInfoEnabled, handleLaunchChat = _a.handleLaunchChat, handleUploadDocuments = _a.handleUploadDocuments, transactionStatus = _a.transactionStatus;
    var eligibleUploadTextKey = transactionStatus === TransactionStatus.SET_22
        ? 'disputeInfo.uploadsOff'
        : 'transactionDisputeStatusDescription.forFurtherInfo';
    if (!showAdditionalMessagingStatus.includes(transactionStatus)) {
        return null;
    }
    if (transactionStatus === TransactionStatus.SET_22 ||
        transactionStatus === TransactionStatus.SET_23) {
        return (_jsx(EligibleUploadText, { children: _jsx(Trans, { i18n: i18n, i18nKey: eligibleUploadTextKey, components: [
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", onClick: handleLaunchChat, "data-type": "dispute-transaction", "data-title": "dispute-transaction", "data-reason": "online chat", "data-object": "button" }, "online chat")
                ] }) }));
    }
    if (additionalInfoEnabled) {
        return (_jsx(EligibleAdditionalInfo, { children: _jsx(Trans, { i18n: i18n, i18nKey: "disputeInfo.additionalInfo", components: [
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    _jsx(UploadButton, { "data-cy": "upload-documents-button", "data-type": "dispute-transaction", "data-title": "dispute-transaction", "data-reason": "Upload document", "data-object": "button", "data-analytics": "clicktrackingevent", buttonType: "text", onClick: handleUploadDocuments }, "upload documents")
                ] }) }));
    }
    return (_jsx(EligibleUploadText, { children: _jsx(Trans, { i18n: i18n, i18nKey: "disputeInfo.uploadsOff", components: [
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _jsx(OnlineChatLink, { "data-analytics": "clicktrackingevent", onClick: handleLaunchChat, "data-type": "dispute-transaction", "data-title": "dispute-transaction", "data-reason": "online chat", "data-object": "button" }, "online chat")
            ] }) }));
};
export default DisputeInfoModalHeaderText;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map